<template>
  <div id="hrms17e-detail2">
    <div class="panel-body">
      <div class="detail detail-responsive">
        <div class="container-fluid">
          <div class="row margin-b-5">
            <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['10'] }}</label>
            <div class="col-sm-2">
              <div class="form-control readonly-field-color">{{ searchIndex.year }}</div>
            </div>
            <label class="col-sm-1 control-label align-right">{{ labels['HRAP32EC2']['20'] }}</label>
            <div class="col-sm-1">
              <div class="form-control readonly-field-color">{{ searchIndex.numtime }}</div>
            </div>
          </div>
          <div class="row margin-b-5">
            <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['30'] }}</label>
            <div class="col-sm-4">
              <div class="form-control readonly-field-color">{{ dataHeader.codempid }} - {{ dataHeader.desc_codempid }}</div>
            </div>
          </div>
   
          <div class="row margin-b-5">
            <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['40'] }}</label>
            <div class="col-sm-4">
              <div class="form-control readonly-field-color">{{ dataHeader.codcomp }} - {{ dataHeader.desc_codcomp }}</div>
            </div>
          </div>
          <div class="row margin-b-5">
            <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['50'] }}</label>
            <div class="col-sm-4">
              <div class="form-control readonly-field-color">{{ dataHeader.codpos }} - {{ dataHeader.desc_codpos }}</div>
            </div>
          </div>
          <div class="row margin-b-5">
            <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EP1']['60'] }}</label>
            <div class="col-sm-4">
              <div class="form-control readonly-field-color">{{ detail.detail.kpino }}</div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['70'] }}</label>
            <div class="col-sm-3 margin-b-5">
              <textarea  class="detail-text input-text width-100" 
                         v-model="detail.detail.kpiitem"
                          v-validate="'required|max:500'" 
                          name="kpiitem" 
                          maxlength="500"
                          :class="{ 'form-control' : true, 'input-error' : errors.has('kpiitem') }"></textarea>
              <div v-show="errors.has('kpiitem')" class="text-error">{{ errors.first('kpiitem') }}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
            </div>
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['90'] }}</label>
            <div class="col-sm-3">
              <textarea class="detail-text input-text width-100" 
                        v-model="detail.detail.target"
                        maxlength="200" 
                        v-validate="'max:200'"
                        data-vv-name="target"
                        :has-error="errors.has('target')"></textarea> 
              <div class="text-error" v-show="errors.has('target')">{{errors.first('target')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div> 
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['80'] }}</label>
            <div class="col-sm-3 margin-b-5">
              <input type="text"  v-model="detail.detail.kpiwgt"
                                  v-validate="'required|between:0,99|max:6'"
                                  maxlength="6" 
                                  name="kpiwgt"
                                  :class="{ 'form-control' : true, 'input-error' : errors.has('kpiwgt') }" />
              <div v-show="errors.has('kpiwgt')" class="text-error">{{ errors.first('kpiwgt') }}</div>
            </div>
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['100'] }}</label>
            <div class="col-sm-3">
              <hrms-datepicker  v-model="detail.detail.dtetarg"
                                v-validate="'date_format:DD/MM/YYYY'"
                                data-vv-value-path="inputDate"
                                name="dtetarg"
                                :has-error="errors.has('dtetarg')" />
              <div class="text-error" v-show="errors.has('dtetarg')">{{errors.first('dtetarg')}}</div>   
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['110'] }}</label>
            <div class="col-sm-3">
              <hrms-dropdown  v-model="detail.detail.mtrunit" 
                              :options="dropdowns.mtrunit[nowLang]"
                              v-validate="'required'" 
                              data-vv-value-path="inputValue"
                              data-vv-name="mtrunit"
                              :has-error="errors.has('mtrunit')" />
            <div class="text-error" v-show="errors.has('mtrunit')">{{errors.first('mtrunit')}}</div>
            </div>
            <label class="col-sm-2 control-label align-right">{{ labels['HRAP32EP1']['120'] }}</label>
            <div class="col-sm-3">
              <input type="number" class="detail-text input-text width-100"  
                              v-model="detail.detail.mtrvalue"
                              v-validate="'required|max:14'" 
                              maxlength="14" 
                              name="mtrvalue" 
                              :class="{ 'form-control' : true, 'input-error' : errors.has('mtrvalue') }" />
              <div v-show="errors.has('mtrvalue')" class="text-error">{{ errors.first('mtrvalue') }}</div> 
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion">  
        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2_tab1">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRAP32EP1']['130'] }}
            </h3>
          </div>
          <div id="details2_tab1" class="panel-collapse collapse in tab-detail">
            <div class="panel-body">
              <hrms-table :columns="detail2Tab1Table" 
                          :data="detail.tab1" 
                          :addInlineEventBool="true"
                          :editInlineEventBool="true"
                          :deleteInlineEventBool="true"
                          :saveInlineEvent="callSaveTab1"
                          :saveInlineBtnDisp="false"
                          :deleteInlineBtnDisp="false"
                          :indexDisp="false" 
                          ref="detail2Tab1Table" />
            </div>
          </div>
        </div>

        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2_tab2">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRAP32EP2']['10'] }}
            </h3>
          </div>
          <div id="details2_tab2" class="panel-collapse collapse tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive">
                <hrms-table :columns="detail2Tab2Table" 
                            :maxRowspan="maxRowspan"
                            :data="detail.tab2" 
                            :addInlineEventBool="true"
                            :editInlineEventBool="true"
                            :deleteInlineEventBool="true"
                            :saveInlineEvent="callSaveTab2"
                            :saveInlineBtnDisp="false"
                            :deleteInlineBtnDisp="false"
                            :indexDisp="false"
                            ref="detail2Tab2Table" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer">  
      <button type="button" class="btn bg-dark-gray" @click="toggle('detail1')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="postDetail2()" value="Save"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
    </div>
  </div>
  
</template>

<script>
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms17e-detail2',
  props: [ 'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'toggle',
    'indexSelected',
    'searchIndex',
    'detail1Selected',
    'detail2Tab1Table',
    'detail2Tab2Table',
    'maxRowspan',
    'inlineDetail2Tab1',
    'setInlineDetail2Tab1',
    'inlineDetail2Tab2',
    'setInlineDetail2Tab2',
    'setDataTab1',
    'setDataTab2',
    'postDetail2Save',
    'dataHeader',
    'dropdowns'
  ],
  data () {
    return {
      regex: require('assets/js/regex')
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    callSaveTab1 (dataRowsHasFlg) {
      this.setInlineDetail2Tab1(dataRowsHasFlg)
    },
    callSaveTab2 (dataRowsHasFlg) {
      this.setInlineDetail2Tab2(dataRowsHasFlg)
    },
    postDetail2 () {
      this.$refs.detail2Tab1Table.$emit('$saveInlineEventBuiltIn')
      this.$refs.detail2Tab2Table.$emit('$saveInlineEventBuiltIn')

      this.$validator.validateAll().then(result => {
        if (result) {
          let _this = this
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            html: true
          },
          function (isConfirm) {
            if (isConfirm) {
              let detail2 = {
                kpino: _this.detail.detail.kpino,
                codcomp: _this.dataHeader.codcomp,
                codpos: _this.dataHeader.codpos,
                kpiitem: _this.detail.detail.kpiitem,
                kpiwgt: _this.detail.detail.kpiwgt,
                target: _this.detail.detail.target,
                dtetarg: _this.detail.detail.dtetarg,
                mtrunit: _this.detail.detail.mtrunit,
                mtrvalue: _this.detail.detail.mtrvalue,
                tab1: _this.inlineDetail2Tab1,
                tab2: _this.inlineDetail2Tab2
              }
              _this.postDetail2Save({
                dataHeader: _this.dataHeader,
                searchIndex: _this.searchIndex,
                detail2: detail2,
                detail1Selected: _this.detail1Selected,
                indexSelected: _this.indexSelected
              })
            }
          })
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
  .width-100 {
    width: 100% !important;
  }
</style>




// WEBPACK FOOTER //
// detail2.vue?566d7036